/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const listSigAssociationsGql = gql`
  query listSigAssociations(
    $limit: Int = 25
    $offset: Int = 0
    $filter: SigAssociationFilter
    $sortBy: SigAssociationSortBy
  ) {
    listSigAssociations(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      count
      result {
        sigId
        sig
        sigStatus
        directionCount
        approvedDrugCount
        createdAt
        updatedAt
      }
    }
  }
`;

// The rows behind the two counts on a sig row, fetched only when someone opens that sig. Keeping
// them off the list query is deliberate: a page of 25 sigs would otherwise pull every direction and
// every drug approval on every load, and the approvals live on a database the list query cannot
// join to at all.
export const listDirectionsForSigGql = gql`
  query listDirectionsForSig($sigId: UUID!, $limit: Int, $offset: Int) {
    listDirectionsForSig(sigId: $sigId, limit: $limit, offset: $offset) {
      count
      result {
        directionId
        direction
        isActive
      }
    }
  }
`;

export const listApprovedDrugsForSigGql = gql`
  query listApprovedDrugsForSig(
    $sigId: UUID!
    $limit: Int
    $offset: Int
    $includeRetired: Boolean
  ) {
    listApprovedDrugsForSig(
      sigId: $sigId
      limit: $limit
      offset: $offset
      includeRetired: $includeRetired
    ) {
      count
      result {
        catalogId
        drugName
        strength
        form
        packSizeValue
        packSizeUnit
        isActive
      }
    }
  }
`;

export const upsertSigAssociationsGql = gql`
  mutation upsertSigAssociations($input: upsertSigAssociationsInput!) {
    upsertSigAssociations(input: $input) {
      success
      sigStatusChanged
      # The sig and its directions are on one database and the catalog approvals on another, so a
      # commit can half-land. Read it separately rather than trusting success alone.
      catalogOutcome {
        applied
        error
        changedCount
      }
      affectedDrugApprovalCount
      affectedDrugApprovals {
        catalogId
        drugName
        strength
        form
        packSizeValue
        packSizeUnit
      }
    }
  }
`;
